import { useState } from "react";
import { HOME_SECTIONS } from "../editors/registry";

// Ana Sayfa editörü — sitedeki her ana sayfa bölümü için alt sekme.
// Bölümler ve editörleri tek kaynaktan (registry) gelir; Görsel Editör ile aynıdır.
export default function HomepageEditor() {
  const [sub, setSub] = useState(HOME_SECTIONS[0].id);
  const current = HOME_SECTIONS.find((s) => s.id === sub) ?? HOME_SECTIONS[0];
  const Editor = current.Editor;

  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-2xl font-bold text-white tracking-tight">Ana Sayfa İçerikleri</h1>
        <p className="text-[#7B8FAF] text-sm mt-0.5">Ana sayfadaki tüm bölümleri buradan veya Görsel Editör'den düzenleyin.</p>
      </div>

      <div className="flex gap-2 flex-wrap">
        {HOME_SECTIONS.map((s) => (
          <button
            key={s.id}
            onClick={() => setSub(s.id)}
            className={`flex items-center gap-2 px-3.5 py-2 rounded-lg text-sm font-medium transition-all cursor-pointer whitespace-nowrap ${
              sub === s.id ? "bg-[#3B82F6]/20 text-white border border-[#3B82F6]/40" : "text-[#7B8FAF] hover:text-white border border-[#2B3654]"
            }`}
          >
            <i className={`${s.icon} text-base`}></i>
            {s.label}
          </button>
        ))}
      </div>

      <div className="bg-[#141E35] border border-[#2B3654] rounded-xl p-6">
        <Editor key={current.id} />
      </div>
    </div>
  );
}
